export default "__VITE_ASSET__HEWWB6Gn__"